import { MunicipalPropertyCatalogRow } from "./municipal-property-catalog-row.model";
import { MunicipalPropertyCreateFormValues } from "./municipal-property-create-form-values";
interface ToMunicipalPropertyFormValuesOptions {
  property: MunicipalPropertyCatalogRow;
  effectiveYear: number;
}
export function toMunicipalPropertyFormValues({
  property,
  effectiveYear,
}: ToMunicipalPropertyFormValuesOptions): MunicipalPropertyCreateFormValues {
  return {
    effectiveYear,
    name: property.name,
    type: property.type,
    description: property.description ?? "",
    street: property.street ?? "",
    houseNumber: property.houseNumber ?? "",
    postalCode: property.postalCode ?? "",
    city: property.city ?? "",
    usableFloorAreaM2: property.usableFloorAreaM2 ?? null,
    commissioningYear: property.commissioningYear ?? null,
    municipalityIdList: property.municipalityList.map(
      (municipality: MunicipalPropertyCatalogRow["municipalityList"][number]): string => municipality.id,
    ),
  };
}
